const SwitchIcon = ({ ...props }) => {
  const color = props?.color || "#1976d2";
  const size = props?.size || "22px";
  const fileSrc = "/public/icon/switch.svg";
  return (
    <div
      style={{
        width: size,
        height: size,
        display: "inline-block",
        verticalAlign: "middle",
        backgroundColor: color,
        maskImage: "url(" + fileSrc + ")",
        maskSize: "contain",
        WebkitMaskImage: "url(" + fileSrc + ")",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      }}
    />
  );
};

export default SwitchIcon;
